import { notification } from 'antd'

export const onConfirmUpload = ({
  setIsLoading,
  uploadFile,
  onSuccessUpload,
  onFailUpload,
  onClose,
  setShowAlert,
  sendUserDataToGTM,
}) => {
  setIsLoading(true)
  notification.close('error_file')
  notification.close('warning_file')
  setShowAlert &&
    setShowAlert((prevState) => {
      return { ...prevState, create: true }
    })
  uploadFile()
    .then((response) => {
      onSuccessUpload && onSuccessUpload(response)
      onClose()
      setShowAlert &&
        setShowAlert((prevState) => {
          return { ...prevState, create: false }
        })
      sendUserDataToGTM && sendUserDataToGTM()
    })
    .catch((error) => {
      onFailUpload && onFailUpload(error)
      onClose()
      setShowAlert &&
        setShowAlert((prevState) => {
          return { ...prevState, create: false }
        })
    })
}
